import token from "./serialize-token";
export const breakpoints = {
    "breakpoints-xs": /* @__PURE__ */ token("0"),
    "breakpoints-sm": /* @__PURE__ */ token("480px"),
    "breakpoints-md": /* @__PURE__ */ token("768px"),
    "breakpoints-lg": /* @__PURE__ */ token("1024px"),
    "breakpoints-xl": /* @__PURE__ */ token("1366px"),
    "breakpoints-2xl": /* @__PURE__ */ token("1584px"),
    "breakpoints-3xl": /* @__PURE__ */ token("1920px"),
    "breakpoints-4xl": /* @__PURE__ */ token("2560px"),
    "breakpoints-5xl": /* @__PURE__ */ token("3840px"),
};

export const gridColumns = {
    "grid-columns-xs": /* @__PURE__ */ token("2"),
    "grid-columns-sm": /* @__PURE__ */ token("6"),
    "grid-columns-md": /* @__PURE__ */ token("12"),
    "grid-columns-lg": /* @__PURE__ */ token("12"),
    "grid-columns-xl": /* @__PURE__ */ token("12"),
    "grid-columns-2xl": /* @__PURE__ */ token("12"),
    "grid-columns-3xl": /* @__PURE__ */ token("12"),
    "grid-columns-4xl": /* @__PURE__ */ token("12"),
    "grid-columns-5xl": /* @__PURE__ */ token("12"),
};

export const gridGutterCompact = {
    "grid-gutter-compact-xs": /* @__PURE__ */ token("8px"),
    "grid-gutter-compact-sm": /* @__PURE__ */ token("8px"),
    "grid-gutter-compact-md": /* @__PURE__ */ token("16px"),
    "grid-gutter-compact-lg": /* @__PURE__ */ token("16px"),
    "grid-gutter-compact-xl": /* @__PURE__ */ token("16px"),
    "grid-gutter-compact-2xl": /* @__PURE__ */ token("16px"),
    "grid-gutter-compact-3xl": /* @__PURE__ */ token("24px"),
    "grid-gutter-compact-4xl": /* @__PURE__ */ token("32px"),
    "grid-gutter-compact-5xl": /* @__PURE__ */ token("40px"),
};

export const gridGutter = {
    "grid-gutter-default-xs": /* @__PURE__ */ token("16px"),
    "grid-gutter-default-sm": /* @__PURE__ */ token("16px"),
    "grid-gutter-default-md": /* @__PURE__ */ token("16px"),
    "grid-gutter-default-lg": /* @__PURE__ */ token("16px"),
    "grid-gutter-default-xl": /* @__PURE__ */ token("16px"),
    "grid-gutter-default-2xl": /* @__PURE__ */ token("24px"),
    "grid-gutter-default-3xl": /* @__PURE__ */ token("32px"),
    "grid-gutter-default-4xl": /* @__PURE__ */ token("40px"),
    "grid-gutter-default-5xl": /* @__PURE__ */ token("48px"),
};

export const gridGutterComfy = {
    "grid-gutter-comfy-xs": /* @__PURE__ */ token("24px"),
    "grid-gutter-comfy-sm": /* @__PURE__ */ token("24px"),
    "grid-gutter-comfy-md": /* @__PURE__ */ token("24px"),
    "grid-gutter-comfy-lg": /* @__PURE__ */ token("24px"),
    "grid-gutter-comfy-xl": /* @__PURE__ */ token("24px"),
    "grid-gutter-comfy-2xl": /* @__PURE__ */ token("32px"),
    "grid-gutter-comfy-3xl": /* @__PURE__ */ token("48px"),
    "grid-gutter-comfy-4xl": /* @__PURE__ */ token("56px"),
    "grid-gutter-comfy-5xl": /* @__PURE__ */ token("64px"),
};

export const gridMarginsCompact = {
    "grid-margins-compact-xs": /* @__PURE__ */ token("16px"),
    "grid-margins-compact-sm": /* @__PURE__ */ token("16px"),
    "grid-margins-compact-md": /* @__PURE__ */ token("24px"),
    "grid-margins-compact-lg": /* @__PURE__ */ token("32px"),
    "grid-margins-compact-xl": /* @__PURE__ */ token("32px"),
    "grid-margins-compact-2xl": /* @__PURE__ */ token("48px"),
    "grid-margins-compact-3xl": /* @__PURE__ */ token("48px"),
    "grid-margins-compact-4xl": /* @__PURE__ */ token("64px"),
    "grid-margins-compact-5xl": /* @__PURE__ */ token("96px"),
};

export const gridMargins = {
    "grid-margins-default-xs": /* @__PURE__ */ token("16px"),
    "grid-margins-default-sm": /* @__PURE__ */ token("16px"),
    "grid-margins-default-md": /* @__PURE__ */ token("32px"),
    "grid-margins-default-lg": /* @__PURE__ */ token("40px"),
    "grid-margins-default-xl": /* @__PURE__ */ token("48px"),
    "grid-margins-default-2xl": /* @__PURE__ */ token("64px"),
    "grid-margins-default-3xl": /* @__PURE__ */ token("72px"),
    "grid-margins-default-4xl": /* @__PURE__ */ token("96px"),
    "grid-margins-default-5xl": /* @__PURE__ */ token("128px"),
};

export const gridMarginsComfy = {
    "grid-margins-comfy-xs": /* @__PURE__ */ token("24px"),
    "grid-margins-comfy-sm": /* @__PURE__ */ token("24px"),
    "grid-margins-comfy-md": /* @__PURE__ */ token("40px"),
    "grid-margins-comfy-lg": /* @__PURE__ */ token("48px"),
    "grid-margins-comfy-xl": /* @__PURE__ */ token("56px"),
    "grid-margins-comfy-2xl": /* @__PURE__ */ token("80px"),
    "grid-margins-comfy-3xl": /* @__PURE__ */ token("96px"),
    "grid-margins-comfy-4xl": /* @__PURE__ */ token("128px"),
    "grid-margins-comfy-5xl": /* @__PURE__ */ token("160px"),
};
